import React, { useEffect, useState, useRef } from "react";

import WebBarChart from "../../../../../elements/barChart";
import "./style.scss";

const barColors = [
  "#FFE5B4",
  "#FF9933",
  "#FFBF00",
  "#FF9032",
  "#FF8C00",
  "#FF7D46",
  "#CC5500",
  "#CC4A00",
  "#9B3A00",
  "#8B4513",
];

function Slide1(props) {
  const mounted = useRef();

  const [data, setData] = useState([]);

  useEffect(() => {
    if (!mounted.current) {
      mounted.current = true;
    } else {
      if (data.length > 0) {
        props.getData({
          type: "image",
          title: "Sales By Sales Summary",
          filter: {
            brands: props.filter.data.brands.map((brand) => brand.name),
            chains: props.filter.data.chains.map((chain) => chain.name),
            revCent: props.filter.data.revCent.map((revCent) => revCent.name),
            payType: props.filter.data.payType.map((payType) => payType.name),
            date: {
              start: props.filter.data.date.start,
              end: props.filter.data.date.end,
            },
          },
          body: {
            table: [
              {
                head: [["Restaurant name", "Total"]],
                body: [
                  ...data?.map((item) => [
                    item?.label,
                    `${item?.currency} ${item?.y?.toFixed(2)}`,
                  ]),
                ],
              },
            ],
            id: "exportPdf_Slide1",
          },
        });
      }
    }
  }, [props.export]);

  useEffect(() => {
    // const slide1Data = Object.values(
    //   props.slideData.reduce(
    //     (a, c) => (
    //       (a[c.restaurant_name] = a[c.restaurant_name]
    //         ? ((a[c.restaurant_name].sessionTotal += c.sessionTotal),
    //           a[c.restaurant_name])
    //         : c),
    //       a
    //     ),
    //     {}
    //   )
    // );

    const slide1DataF = props.slideData?.map((item, idx) => {
      const totalSales = item.totalOpenSales + item.totalClosedSales;
      return {
        y: totalSales,
        value: totalSales,
        label: item.restaurant_name,
        name: item.restaurant_name,
        displayValue: `${item?.currency} ${totalSales?.toFixed(2)}`,
        currency: item?.currency,
        openSales: `${item?.currency} ${item.totalOpenSales?.toFixed(2)}`,
        closedSales: `${item?.currency} ${item.totalClosedSales?.toFixed(2)}`,
        color: barColors[idx % barColors.length],
      };
    });

    setData(slide1DataF);
  }, [props.slideData]);

  return (
    <div id={"exportPdf_Slide1"}>
      <div
        style={{
          height: Math.max(data.length * 60 || 0, 300),
          overflowY: "auto",
        }}
      >
        {/* className="sales-summary-chart-container"> */}
        <WebBarChart chartData={data} />
      </div>
    </div>
  );
}

export default Slide1;
